import { contact } from 'data/bio';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import styles from './contactsection.module.scss';

const platformIcon: Record<string, React.ReactNode> = {
  GitHub: <GitHubIcon fontSize="small" />,
  LinkedIn: <LinkedInIcon fontSize="small" />,
};

const ContactSection: React.FC = () => {
  return (
    <section id="contact-section-root" className={styles.contactSectionRoot}>
      <div className={styles.sectionContainer}>
        <h1>contact</h1>

        {contact.blurb && (
          <p className={styles.blurb}>{contact.blurb}</p>
        )}

        <div className={styles.contactList}>
          {contact.email && (
            <a href={`mailto:${contact.email}`} className={styles.contactRow}>
              <span className={styles.contactIcon}>
                <EmailOutlinedIcon fontSize="small" />
              </span>
              <span className={styles.contactLabel}>email</span>
              <span className={styles.contactValue}>{contact.email}</span>
            </a>
          )}

          {contact.location && (
            <div className={styles.contactRow}>
              <span className={styles.contactIcon}>
                <LocationOnOutlinedIcon fontSize="small" />
              </span>
              <span className={styles.contactLabel}>location</span>
              <span className={styles.contactValue}>{contact.location}</span>
            </div>
          )}

          {contact.website && (
            <a href={contact.website} target="_blank" rel="noopener noreferrer" className={styles.contactRow}>
              <span className={styles.contactIcon}>
                <LanguageIcon fontSize="small" />
              </span>
              <span className={styles.contactLabel}>web</span>
              <span className={styles.contactValue}>{contact.website}</span>
            </a>
          )}

          {contact.socialLinks.map(link => (
            <a key={link.platform} href={link.url} target="_blank" rel="noopener noreferrer" className={styles.contactRow}>
              <span className={styles.contactIcon}>
                {platformIcon[link.platform] ?? null}
              </span>
              <span className={styles.contactLabel}>{link.platform.toLowerCase()}</span>
              <span className={styles.contactValue}>{link.url}</span>
            </a>
          ))}

          <div className={styles.resumeRow}>
            <span className={styles.contactIcon}>
              <FileDownloadOutlinedIcon fontSize="small" style={{ color: contact.resumeUrl ? '#56642A' : '#aaa' }} />
            </span>
            <span className={styles.contactLabel}>resume</span>
            {contact.resumeUrl ? (
              <a href={contact.resumeUrl} download className={styles.resumeLink}>
                Download PDF
              </a>
            ) : (
              <span className={styles.resumeDisabled}>
                Download PDF (coming soon)
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
